import Head from "next/head"
import {NextPage, GetStaticProps} from "next";
import {Container, Typography, Divider, Grid, Box} from "@mui/material";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {useTranslation} from "next-i18next";
import {MainNavbar} from "../src/components/main-navbar";
import {useState} from "react";
import {MainSidebar} from "../src/components/main-sidebar";
import {FooterPre} from "../src/components/footer-pre";
import {Footer} from "../src/components/footer";
import {SeaCrushHeartWhite} from "../src/icons/seacrush-heart-white";
import Image from "next/legacy/image";
import googleBucketLoader from "../src/lib/google-bucket-loader";
import {Link} from "../src/components/link"

/*
#landing-hero {
  min-height: 100%;
  background-color: #000;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  position: relative;
  color: #fff;
  font-weight: 500;
  font-family: $secondaryFont;

  .hero-intro {
    font-size: 1.6rem;
  }

  .hero-subintro {
    font-size: 1.6rem;
    line-height: 1.8rem;
  }

  @media screen and (min-height: 550px) {
    min-height: 550px;
  }

  @media screen and (min-height: 700px) {
    min-height: 700px;
    .hero-intro {
      margin-top: 30px;
    }
  }

}

 */


const AboutPage: NextPage = () => {
    const {t} = useTranslation()
    const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);

    return (
        <div>
            <Head>
                <title>{t("title-about") + " | SeaCrush"}</title>
            </Head>


            <div style={{
                minHeight: "100%",
                backgroundColor: "#000",
                backgroundSize: "cover",
                backgroundPosition: "center center",
                backgroundRepeat: "no-repeat",
                position: "relative",
                backgroundImage: "url('/images/about/about_us_hero.webp')"
            }}>
                <MainNavbar hero={true} onOpenSidebar={(): void => setIsSidebarOpen(true)}/>
                <MainSidebar
                    onClose={(): void => setIsSidebarOpen(false)}
                    open={isSidebarOpen}
                />

                <Container maxWidth='md' sx={{minHeight: 600, textAlign: "center", mt: 5, pt: 5}}>
                    <SeaCrushHeartWhite htmlColor={"#fff"} style={{height: 50, width: 50}} sx={{mt: 2}}/>
                    <Typography sx={{mb: 2}} component={"h1"} variant={"button"}
                                color={"white"}>{t("title-about")}</Typography>
                    <Divider sx={{maxWidth: 140, margin: "0 auto"}}/>

                    <Typography sx={{mb: 2, mt: 2}} component={"p"} variant={"subtitle1"}
                                color={"white"}>{t("about.intro")}</Typography>
                    <Typography sx={{mb: 2, mt: 2}} component={"p"} variant={"subtitle1"}
                                color={"white"}>{t("about.sub-intro")}</Typography>

                </Container>


            </div>
            <div style={{backgroundColor: "#fff"}}>


                <Container maxWidth='md' sx={{pb:2}}>
                    <Box textAlign={"center"} sx={{pt:4, pb:2}}>
                        <Typography component={"div"} sx={{maxWidth: 400, display: "inline-block"}}
                                    variant={"body1"}>{t("about.sub-sub-intro-1")}
                        </Typography>
                        <br/>
                        <Link href={"/concept"}>
                            <Typography component={"div"} sx={{maxWidth: 400, display: "inline-block"}}
                                        color={"primary"}
                                        variant={"body1"}>{t("about.sub-sub-intro-2")}</Typography>
                        </Link>

                        <Divider sx={{maxWidth: 800, mx: "auto", mt:4}}/>
                    </Box>

                    <Grid container>
                        <Grid item xs={12} sm={6} sx={{pt: {sm: 10, xs: 3}}} order={{xs: 2, sm: 1}}>
                            <Typography component={"p"} variant={"h4"}>{t("about.heading-michael")}</Typography>
                            <Typography component={"p"} color={"primary.dark"} sx={{fontWeight: "bold"}}
                                        variant={"body2"}>{t("about.role-michael")}</Typography>
                            <Typography component={"p"}
                                        variant={"body1"}>&ldquo;{t("about.quote-michael")}&rdquo;</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} sx={{p: 4}} order={{xs: 1, sm: 2}}>
                            <Image
                                loader={googleBucketLoader}
                                src={"/images/about/about_page_michael.webp"} layout={"responsive"}
                                   width={352}
                                   height={352}/>
                        </Grid>

                    </Grid>

                    <Grid container>
                        <Grid item xs={12} sm={6} sx={{p: 4}}>
                            <Image
                                loader={googleBucketLoader}
                                src={"/images/about/about_page_isabelle.webp"} layout={"responsive"}
                                   width={352}
                                   height={352}/>
                        </Grid>
                        <Grid item xs={12} sm={6} sx={{pt: {sm: 10, xs: 3}}}>
                            <Typography component={"p"} variant={"h4"}>{t("about.heading-isa")}</Typography>
                            <Typography component={"p"} color={"primary.dark"} sx={{fontWeight: "bold"}}
                                        variant={"body2"}>{t("about.role-isa")}</Typography>
                            <Typography component={"p"}
                                        variant={"body1"}>&ldquo;{t("about.quote-isa")}&rdquo;</Typography>
                        </Grid>
                    </Grid>
                </Container>
            </div>

            <FooterPre/>
            <Footer/>

        </div>
    )
}


export const getStaticProps: GetStaticProps = async ({locale}) => ({
    props: {
        ...(await serverSideTranslations(locale as string, ["frontend"])),
    },
})


export default AboutPage
